import { Box, Button, List, ListItem, ListItemText, Typography } from '@mui/material';
import { FC, useState } from 'react';
import { Notice } from 'ui/Notice';
import { NoticeDialog } from 'ui/NoticeDialog';

export const CustomDescriptionNotice: FC = () => {
	const [open, setOpen] = useState(false);
	const setClose = () => setOpen(false);

	return (
		<Notice
			sx={{
				marginTop: 1,
				// height: '100%',
			}}
		>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					gap: 0,
					justifyContent: 'start',
					alignItems: 'start',
					height: '100%',
				}}
			>
				<Typography variant="body2" sx={{ fontSize: '.9rem' }}>
					The item description in German should be included here for customs purposes. Please,
					provide details about the item, focusing on its intended use and the materials it is made
					from.
				</Typography>
				<Button
					sx={{
						m: 0,
						p: 0,
						fontWeight: 'bold',
					}}
					onClick={() => setOpen(true)}
				>
					More detailed guide here
				</Button>
			</Box>
			<NoticeDialog open={open} setClose={setClose} title="Customs Description Guidelines">
				<Box sx={{ p: 0, color: 'primary.main' }}>
					<Typography variant="body2" color="text.secondary">
						To ensure smooth customs clearance, please provide a concise description of each order
						item in German, adhering to the following guidelines (maximum 240 characters per item):
					</Typography>
					<List>
						<ListItem>
							<ListItemText
								color="primary"
								primary="1. Intended Use"
								secondary={
									<div>
										Clearly state the purpose of the item.
										<br />
										<b>Examples:</b> Wristwatch, Electric kitchen appliance, Imitation jewelry,
										Women&apos;s clothing, Printed book.
										<br />
										<b>If necessary, provide more detail:</b> Fully mechanical wristwatch with a
										wristband, Girl’s t-shirt, Winter and all-weather hiking boots with removable
										insoles.
									</div>
								}
							/>
						</ListItem>
						<ListItem>
							<ListItemText
								primary="2. Materials Used"
								secondary={
									<div>
										Specify the materials where applicable.
										<br />
										<b>Examples:</b> Imitation jewelry made from non-precious metals with natural
										pearls, Enamel pin with natural stone elements, Girl’s t-shirt with at least 60%
										cotton content, Men’s shoes with full leather upper and rubber soles.
									</div>
								}
							/>
						</ListItem>
						<ListItem>
							<ListItemText
								primary="3. Special Characteristics"
								secondary={
									<div>
										Include relevant specifics.
										<br />
										<b>Examples:</b> Essential natural oil infusion, not for human consumption as
										food, Lightweight protective helmet, not suitable for children or professional
										use, Sunglasses with plastic lenses, not made with a medical prescription or for
										medical purposes.
									</div>
								}
							/>
						</ListItem>
					</List>
					<Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
						Tip: Use the HS code as a reference when describing the intended use and materials, as
						the HS code description is shown next to the respective field.
					</Typography>
				</Box>
			</NoticeDialog>
		</Notice>
	);
};
